import { createContext, useContext, useState, type ReactNode } from 'react';

import type { CreateResumeRoute } from 'src/components/Profile/CreateResume/types';
import type { Card } from 'src/types';

export interface ScrollContextState {
  inView: Card | CreateResumeRoute | '';
}

export interface ScrollContextType extends ScrollContextState {
  setScrollParams: (params: Partial<ScrollContextType>) => void;
}

const ScrollContext = createContext<ScrollContextType | undefined>(undefined);

export const ScrollProvider = ({ children }: { children: ReactNode }) => {
  const [scrollParams, setScrollParams] = useState<ScrollContextState>({
    inView: '',
  });

  const updateScrollParams = (params: Partial<ScrollContextState>) => {
    setScrollParams((prev) => ({ ...prev, ...params }));
  };

  return (
    <ScrollContext.Provider
      value={{
        ...scrollParams,
        setScrollParams: updateScrollParams,
      }}
    >
      {children}
    </ScrollContext.Provider>
  );
};

export const useScrollContext = (): ScrollContextType => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error('useScrollContext must be used within a ScrollProvider');
  }
  return context;
};
